export class devGame {
	constructor(aRoomCode = "MOCK") {
		this.game.id = aRoomCode;
	}
	connected = false;
	game = {
		joined: true,
		players: [
			{ id: 0, pos: 0, name: "Irakli" },
			{ id: 1, pos: 1, name: "Dea" },
			{ id: 2, pos: 2, name: "Shio" },
			{ id: 3, pos: 3, name: "Mari" },
		],
		disconnectedPlayers: [],
		state: {
			inProgress: false,
			paused: false,
			cards: {},
			lastTaken: {},
			lastTakenPlayer: null,
			remainingValues: [],
			scores: {
				0: 0,
				1: 0,
			},
			turn: 2,
			winner: null,
		},
		settings: {
			values: ["6", "7", "8", "9", "10", "J", "Q", "K", "A"],
			suits: ["clubs", "diamonds", "hearts", "spades"],
			numPlayers: 4,
		},
		me: 2,
	};
	errors = [];
}
